export interface IFormIdService {
  getId: () => string;
  setId: (id: string) => void;
}

export const LOCAL_STORAGE_ITEM_NAME = 'CA_formID';

let formId: string;

/**
 * @deprecated Используй селектор selectAnalyticsFormId
 */
export const getFormId = () => {
  return formId;
};

export const formIdService = (): IFormIdService => {
  const setId = (id: string) => {
    formId = id;
  };

  return {
    getId: getFormId,
    setId,
  };
};
